<template>
  <div>
  <section>
			<div class="container">
				<figure><img src="/static/images/index/i80banner.png" class="img-responsive"></figure>
			</div>
		</section>
        <section>
            <div class="container">
                <ol class="breadcrumb hidden-xs">
                    <li><a href="/">首頁</a></li>
                    <li><a href="/member">會員中心</a></li>
                    <li class="active">註冊</li>
                </ol>
                <div class="row">
                    <div class="col-sm-offset-3 col-sm-6">
                        <h4 class="text-center">會員註冊</h4>
                        <div class="register_form">
                            <form class="form-horizontal">
                                <div class="form-group">
                                    <label for="account" class="col-sm-3 control-label">*帳號(Email)</label>
                                    <div class="col-sm-6">
                                    <input type="email" class="form-control" v-model="account" placeholder="請勿輸入特殊符號 如:&*_#等符號">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="password" class="col-sm-3 control-label">*設定密碼</label>
                                    <div class="col-sm-6">
                                      <input :type="passwordType ? 'password' : 'text'" class="form-control" v-model="password" id="password" placeholder="密碼">
                                      <input type="checkbox" :checked="displaypwd" @click="onChange($event)"/> 顯示密碼
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="password" class="col-sm-3 control-label">*再次輸入密碼</label>
                                    <div class="col-sm-6">
                                      <input type="password" class="form-control" v-model="doublepassword" id="doublepassword" placeholder="再次輸入密碼">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="name" class="col-sm-3 control-label">*姓名</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="請填寫中文本名">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">*行動電話</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" maxlength="10" v-model="phone" id="phone" placeholder="行動電話">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="idno" class="col-sm-3 control-label">*身分證字號/居留證號碼</label>
                                    <div class="col-sm-6">
                                        <input type="text" class="form-control" maxlength="10" v-model="identify" id="idno" placeholder="身分證字號">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="address" class="col-sm-3 control-label">地址</label>
                                    <div class="col-sm-4">
                                        <select class="form-control" v-model="countyval">
                                            <option v-for="option in county" v-bind:value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4">
                                        <select class="form-control" v-model="districtval">
                                            <option v-for="option in district" v-bind:value="option.value">
                                                {{option.text}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="address" class="col-sm-3 control-label"></label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="address">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="phone" class="col-sm-3 control-label">推薦人編號</label>
                                    <div class="col-sm-6">
                                        <input type="number" class="form-control" v-model="parentid" :disabled="validated == 1" id="parentid" placeholder="推薦人編號">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="col-sm-offset-3 col-sm-9">
                                        <div class="checkbox">
                                            <label>
                                                <input type="checkbox" value="1" v-model="member_policy"/>
                                                我同意<a href="/member_policy" target="_blink">遵守「會員條款」之內容</a>
                                            </label>
                                            <label>
                                                <input type="checkbox" value="1" v-model="agreement"/>
                                                我同意<a href="/privacy" target="_blink">「隱私權政策」之內容</a>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">

                                    <div class="col-sm-offset-3 col-sm-9">
                                        <pulse-loader :loading="loading" ></pulse-loader>
                                        <button type="button" class="btn btn-default" @click="register()" :disabled="this.flag">註冊</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
export default {
  name: 'Register',
  data () {
    return {
      apiurl: 'https://affiliate.i80.com.tw/',
      rowData: {},
      agreement: true,
      member_policy: true,
      account: '',
      password: '',
      doublepassword: '',
      name: '',
      phone: '',
      parentid: '',
      identify: '',
      countyval: '',
      districtval: '',
      county: this.$store.getters.getCounty,
      district: [],
      address: '',
      validated: 0,
      flag: false,
      loading: false,
      displaypwd: false,
      passwordType: true,
      smsButtonDisabled: false,
      countyCode: {
        A: '10', // 台北市
        B: '11', // 台中市
        C: '12', // 基隆市
        D: '13', // 台南市
        E: '14', // 高雄市
        F: '15', // 新北市
        G: '16', // 宜蘭縣
        H: '17', // 桃園市
        I: '34', // 嘉義市 (省轄)
        J: '18', // 新竹縣
        K: '19', // 苗栗縣
        L: '20', // 台中縣 (停發)
        M: '21', // 南投縣
        N: '22', // 彰化縣
        O: '35', // 新竹市 (省轄)
        P: '23', // 雲林縣
        Q: '24', // 嘉義縣
        R: '25', // 台南縣 (停發)
        S: '26', // 高雄縣 (停發)
        T: '27', // 屏東縣
        U: '28', // 花蓮縣
        V: '29', // 台東縣
        W: '32', // 金門縣
        X: '30', // 澎湖縣
        Y: '31', // 陽明山 (停發)
        Z: '33' // 連江縣
      }
    }
  },
  components: {
    PulseLoader
  },
  mounted: function () {
    let parentID = this.$route.params.id
    if (parentID) {
      this.parentid = parentID
      localStorage.setItem('shareid', parentID)
    } else {
      this.parentid = localStorage.getItem('shareid')
    }
    if (this.parentid) {
      this.validated = 1
    }
  },
  methods: {
    ...mapActions([
      'getShareid'
    ]),
    onChange () {
      this.displaypwd = true
      if (this.passwordType === true) {
        this.passwordType = false
      } else {
        this.passwordType = true
      }
    },
    isNewResidenceCertificateNumberValid (id) {
      // 新制居留證，民國 110/01/02 啟用
      // e.g. 'A800000014'
      // 第一碼 區域碼; 第二碼 性別碼 8,9; 第三至九碼 流水號; 第十碼 檢查碼
      // 第一碼換成區域代碼
      // 共 11 碼，前十碼 乘以權重後取個位數 再相加 得到基數
      // 10 - 基數的個位數 = 最後一碼檢查碼 (如果基數的個位數是 0，則檢查碼為 0)
      const regex = /^([A-Z])[8,9]\d{8}$/
      if (typeof id !== 'string') return false
      if (!regex.test(id)) return false

      const county = id.match(regex)[1]
      const code = id.replace(county, this.countyCode[county])

      const codeArr = code.split('').map(c => parseInt(c, 10))
      const evaluationValue = codeArr.splice(-1, 1)[0]
      const multiplier = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1]
      const base = codeArr.reduce((prev, curr, idx) => prev + (curr * multiplier[idx]) % 10, 0)
      const evaluationCode = (base % 10 === 0) ? 0 : 10 - (base % 10)
      const isValid = evaluationCode === evaluationValue
      return isValid
    },
    isOldResidenceCertificateNumberValid (id) {
      // 舊制居留證，民國 120/01/01 起停用
      // e.g. 'AD1994479'
      // 第一碼 區域碼; 第二碼 性別碼 ABCD; 第三至九碼 流水號; 第十碼 檢查碼
      // 第一碼換成區域代碼
      // 第二碼換成區域代碼取個位數
      // 共 11 碼用權重相加，應為 10 的倍數
      const regex = /^([A-Z])([A,B,C,D])\d{8}$/
      if (typeof id !== 'string') return false
      if (!regex.test(id)) return false

      const county = id.match(regex)[1]
      const sex = id.match(regex)[2]
      const code = id
        .replace(`${county}${sex}`, `${this.countyCode[county]}${parseInt(this.countyCode[sex], 10) % 10}`)

      const multiplier = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
      const evaluateValue = code.split('').reduce((prev, curr, idx) => prev + curr * multiplier[idx], 0)

      const isValid = (evaluateValue % 10) === 0
      return isValid
    },
    isNationalIdNumberValid (id) {
      // 身分證字號
      // e.g. 'A123456789'
      // 第一碼換成區域代碼
      // 共 11 碼用權重相加，應為 10 的倍數
      const regex = /^([A-Z])[1,2]\d{8}$/
      if (typeof id !== 'string') return false
      if (!regex.test(id)) return false

      const county = id.match(regex)[1]
      const code = id.replace(county, this.countyCode[county])

      const multiplier = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
      const evaluateValue = code.split('').reduce((prev, curr, idx) => prev + curr * multiplier[idx], 0)

      const isValid = (evaluateValue % 10) === 0
      return isValid
    },
    register () {
      try {
        /*eslint-disable */
        let email = this.account.toLowerCase()
        let str = ''
        if (this.name === '') {
          str += '請填寫個人姓名。\n'
        } else if (email === '' || !email) {
          str += '請輸入您的 Email\n'
        } else if (this.password === '' || !this.password) {
          str += '請輸入您的密碼\n'
        } else if (this.phone === '' || !this.phone) {
          str += '請輸入您的聯絡電話\n'
        } else if (this.identify === '' || !this.identify) {
          str += '請輸入您的身分證字號\n'
        } else if (!this.agreement) {
          str += '請勾選同意隱私權政策。\n'
        } else if (!this.member_policy) {
          str += '請勾選同意會員條款。\n'
        }

        const rulename = new RegExp('^[\u4e00-\u9fa5_a-zA-Z]+$')
        if (!rulename.test(this.name)) {
          str += '您的姓名只能輸入中文或英文。\n'
        }

        const ruleemail = new RegExp('^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$')
        if (!ruleemail.test(email)) {
          str += '您輸入 Email 格式不正確。\n'
        }

        let identifyId = this.identify

        if (!this.isNationalIdNumberValid(identifyId) && !this.isNewResidenceCertificateNumberValid(identifyId) && !this.isOldResidenceCertificateNumberValid(identifyId)) {
          str += '您輸入「身分證字號」或「居留證號碼」不合法。\n'
        }

        const rulep = new RegExp('^[09]{2}[0-9]{8}$')
        if (!rulep.test(this.phone)) {
          str += '您輸入的手機格式不正確。\n'
        }

        const password_rule = new RegExp('^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,20}$');
        if (!password_rule.test(this.password)) {
          str += '密碼格式不符，至少超過 6 碼，且包含數字及大小寫英文\n'
        }
        if (this.password !== this.doublepassword) {
          str += '您兩次輸入的密碼不正確。\n'
        }
        /*
        if (this.countyval === '' || this.districtval === '') {
          str += '請選擇縣市及區域\n'
        }
        if (this.address === '') {
          str += '請填寫地址\n'
        }
        */
        if (str === '' && this.flag === false) {
          this.loading = true
          this.flag = true
          this.$http.post(this.apiurl + 'api/register', {
            email: email,
            org_account: this.account,
            password: this.password,
            org_cellphone: this.phone,
            parent_id: this.parentid,
            org_name: this.name,
            org_identify: this.identify.toUpperCase(),
            org_country: this.countyval,
            org_town: this.districtval,
            org_address: this.address,
            user_agent: navigator.userAgent,
            org_from: 'website'
          }).then(function (res) {
            console.log(res)
            this.loading = false
            let response = res.body
            let id = response.id
            if (response.status === 200) {
              window.alert('註冊成功，您的編號為:' + id)
              this.$router.go('/')
            } else {
              window.alert('註冊失敗，此組『信箱』或『身份證』，已註冊過帳號。')
              this.flag = false
            }
          }, function (res) {
            console.log('failed')
            console.log(res)
          })
        } else {
          window.alert(str)
        }
      } catch (error) {
				window.alert(error)
			}
    }
  },
  computed: {
    ...mapGetters([
      'getCounty'
    ])
  },
  watch: {
    countyval: {
      handler: function (val, oldVal) {
        let key = parseInt(val) - 1
        let district = this.$store.getters.getDistrict
        this.district = district[key]
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Register.vue?067bd424